import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/common/PageHeader";
import { AppointmentCTA } from "@/components/sections/AppointmentCTA";
import { Reveal } from "@/components/common/Reveal";
import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function Doctors() {
  const [doctors, setDoctors] = useState([]);
  useEffect(() => { api.get("/doctors").then((r) => setDoctors(r.data)).catch(() => {}); }, []);

  return (
    <>
      <Seo title="Our Doctors" description="Meet the experienced, ethical clinicians at the Center Of Dental Treatment." path="/doctors" />
      <PageHeader eyebrow="Meet Your Dentists" title="Experienced hands, ethical hearts" subtitle="Two dedicated clinicians, each with over two decades of experience, united by a patient-first philosophy." />

      <section className="py-14 lg:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-8">
          {doctors.map((d, i) => (
            <Reveal key={d.slug} delay={i * 0.08}>
              <div className="h-full rounded-[var(--cdt-radius-md)] bg-white border border-[color:var(--cdt-border)] shadow-[var(--cdt-shadow-sm)] overflow-hidden">
                <div className="h-64 overflow-hidden"><img src={d.image} alt={d.name} loading="lazy" className="w-full h-full object-cover" /></div>
                <div className="p-6">
                  <h2 className="font-display text-2xl text-[var(--cdt-text)]">{d.name}</h2>
                  <p className="text-sm text-[var(--cdt-primary)] font-medium mt-0.5">{d.title}</p>
                  <div className="flex flex-wrap gap-1.5 mt-3">
                    {d.qualifications.map((q) => <Badge key={q} variant="secondary" className="bg-[var(--cdt-surface-2)] text-[var(--cdt-text)]">{q}</Badge>)}
                    <Badge className="bg-[rgba(15,92,90,0.1)] text-[var(--cdt-primary)] hover:bg-[rgba(15,92,90,0.1)]">{d.experience}</Badge>
                  </div>
                  <p className="mt-4 text-sm leading-7 text-[var(--cdt-muted)] line-clamp-3">{d.philosophy}</p>
                  <Link to={`/doctors/${d.slug}`} data-testid={`doctor-profile-link-${d.slug}`} className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--cdt-primary)]">View full profile <ArrowRight className="h-4 w-4" /></Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <AppointmentCTA />
    </>
  );
}
